export const SCID_MATCH = 'ScidMatch'
export const TAG = 'Tag'
